/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `exd_data_field_configuration` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class ExdDataFieldConfigurationMesg : Mesg {
    public constructor() : super("ExdDataFieldConfiguration", Profile.MesgNum.EXD_DATA_FIELD_CONFIGURATION)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** screen_index. */
    public var screenIndex: UByte?
        get() = getFieldValue(SCREEN_INDEX_FIELD_NUM) as? UByte
        set(value) = setFieldValue(SCREEN_INDEX_FIELD_NUM, value)

    /** concept_field. */
    public var conceptField: UByte?
        get() = getFieldValue(CONCEPT_FIELD_FIELD_NUM) as? UByte
        set(value) = setFieldValue(CONCEPT_FIELD_FIELD_NUM, value)

    /** field_id. */
    public var fieldId: UByte?
        get() = getFieldValue(FIELD_ID_FIELD_NUM) as? UByte
        set(value) = setFieldValue(FIELD_ID_FIELD_NUM, value)

    /** concept_count. */
    public var conceptCount: UByte?
        get() = getFieldValue(CONCEPT_COUNT_FIELD_NUM) as? UByte
        set(value) = setFieldValue(CONCEPT_COUNT_FIELD_NUM, value)

    /** display_type. */
    public var displayType: ExdDisplayType?
        get() = (getFieldValue(DISPLAY_TYPE_FIELD_NUM) as? UByte)?.let { ExdDisplayType.fromValue(it) }
        set(value) = setFieldValue(DISPLAY_TYPE_FIELD_NUM, value?.value)

    /** Number of values stored in title. */
    public val numTitle: Int
        get() = getField(TITLE_FIELD_NUM)?.numValues ?: 0

    /** title. */
    public var title: List<String?>?
        get() {
            val field = getField(TITLE_FIELD_NUM) ?: return null
            return List(field.numValues) { getTitle(it) }
        }
        set(value) {
            removeField(TITLE_FIELD_NUM)
            value?.forEachIndexed { index, element -> setTitle(index, element) }
        }

    public fun getTitle(index: Int): String? =
        getFieldValue(TITLE_FIELD_NUM, index) as? String

    public fun setTitle(index: Int, value: String?) {
        setFieldValue(TITLE_FIELD_NUM, value, index)
    }

    public companion object {
        public const val SCREEN_INDEX_FIELD_NUM: UByte = 0u
        public const val CONCEPT_FIELD_FIELD_NUM: UByte = 1u
        public const val FIELD_ID_FIELD_NUM: UByte = 2u
        public const val CONCEPT_COUNT_FIELD_NUM: UByte = 3u
        public const val DISPLAY_TYPE_FIELD_NUM: UByte = 4u
        public const val TITLE_FIELD_NUM: UByte = 5u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("ScreenIndex", 0u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[1] = Field("ConceptField", 1u, BaseType.BYTE, 1.0, 0.0, "", false)
                .addComponent(FieldComponent(2u, false, 4, 1.0, 0.0))
                .addComponent(FieldComponent(3u, false, 4, 1.0, 0.0))
            fields[2] = Field("FieldId", 2u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[3] = Field("ConceptCount", 3u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[4] = Field("DisplayType", 4u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[5] = Field("Title", 5u, BaseType.STRING, 1.0, 0.0, "", false)
            return fields
        }
    }
}
